<template>
  <div class="order-steps">
    <ul class="order-steps__list">
      <li
        v-for="(item, index) in orderStepsData"
        :key="index"
        :class="containerClasses(index)"
        class="order-steps__item text--bold"
      >
        <span
          v-if="isSuccessfull(index)"
          class="order-steps__sequence order-steps__sequence--success"
        >
          <nuxt-link
            :to="item.route"
            data-tealium-rel="header.button.warenkorb"
            class="order-steps btn btn--transparent btn--borderless"
            :aria-label="item.label"
          >
            <svg-icon
              class="icon icon__check order-steps__icon--success"
              :image="CheckIcon"
            />
          </nuxt-link>
        </span>
        <span
          v-if="!isSuccessfull(index)"
          class="order-steps__sequence"
        >
          {{ index + 1 }}
        </span>
        <span class="order-steps__title">{{ item.label }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import CheckIcon from '@/assets/images/check.svg';
import { mapGetters } from 'vuex';

export const ORDER_STEPS = [
  {
    id: 'cart',
    label: 'Warenkorb',
    route: '/shop/warenkorb',
  },
  {
    id: 'address',
    label: 'Adressdaten',
    route: '/shop/kundenformular/persoenliche-daten',
  },
  {
    id: 'payment',
    label: 'Zahlung',
    route: '/shop/kundenformular/zahlungsart',
  },
  {
    id: 'summary',
    label: 'Bestellung absenden',
    route: '/shop/shop/zusammenfassung',
  },
];

export default {
  name: 'OrderSteps',
  props: {
    step: {
      type: String,
      validator(value) {
        return ORDER_STEPS.map((os) => os.id).includes(value);
      },
      default() {
        return 'cart';
      },
    },
  },
  data() {
    return {
      CheckIcon,
    };
  },
  computed: {
    ...mapGetters('cart', ['wasPaypalExpressReceived', 'isFreeOfChargeCart']),
    orderStepsData() {
      if (this.wasPaypalExpressReceived || this.isFreeOfChargeCart)
        return ORDER_STEPS.filter((os) => os.id !== 'payment');
      return ORDER_STEPS;
    },
    currentStep() {
      return this.orderStepsData.findIndex((os) => os.id === this.step);
    },
  },
  methods: {
    isSuccessfull(index) {
      return this.currentStep > index;
    },
    containerClasses(index) {
      const modifier = [];
      if (this.currentStep > index) modifier.push('order-steps__item--success');
      if (this.currentStep === index) modifier.push('order-steps__item--active');
      return modifier;
    },
  },
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.order-steps {
  margin: 2 * $grid-base auto;
  padding-inline: $grid-base;
  width: 100%;

  @include mq($mq-md) {
    margin-top: 4 * $grid-base;
    margin-bottom: 4 * $grid-base;
  }

  &.btn {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  &.btn--transparent {
    border-color: transparent;
    &:hover,
    &:focus {
      border-color: transparent;
      background: transparent;
    }
    &:link,
    &:visited {
      color: color(white);
    }
  }

  &__list {
    margin-right: auto;
    margin-left: auto;
    max-width: 650px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    position: relative;
  }

  &__item {
    position: relative;
    display: flex;
    list-style: none;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
    width: 100%;
    color: color(grey, 16000);

    &::after {
      content: '';
      position: absolute;
      height: 2px;
      background-color: color(grey, 16000);
      top: 18px;
      z-index: 0;
      width: 100%;
      left: 50%;
    }

    &:last-child {
      &::after {
        display: none;
      }
    }

    // Modifier
    &--success {
      color: var(--color-success);

      &::after {
        background-color: var(--color-success);
      }
    }

    &--active {
      color: var(--color-primary);
    }
  }

  &__sequence {
    width: 36px;
    height: 36px;
    border: 2px solid;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: color(white);
    position: relative;
    z-index: 1;
    @include font-size(18px, 20px);

    &--success {
      background: var(--color-success);
      color: color(white);
      border-color: var(--color-success);
    }
  }

  &__title {
    font-size: 19px;
    display: none;

    @include mq($mq-sm) {
      display: inline-block;
    }
  }
}
</style>
